module.exports = __webpack_public_path__ + "img/notifications-illustration.8889a749.svg";